/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListChatSessionLinksSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type ListChatSessionLinksSecurityOption2 = {
  chatSessionsTokenHeaderGramChatSession: string;
};

export type ListChatSessionLinksSecurity = {
  option1?: ListChatSessionLinksSecurityOption1 | undefined;
  option2?: ListChatSessionLinksSecurityOption2 | undefined;
};

export type ListChatSessionLinksRequest = {
  /**
   * Chat ids to resolve links for.
   */
  chatIds: Array<string>;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  /**
   * Chat Sessions token header
   */
  gramChatSession?: string | undefined;
};

/** @internal */
export type ListChatSessionLinksSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const ListChatSessionLinksSecurityOption1$outboundSchema: z.ZodMiniType<
  ListChatSessionLinksSecurityOption1$Outbound,
  ListChatSessionLinksSecurityOption1
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listChatSessionLinksSecurityOption1ToJSON(
  listChatSessionLinksSecurityOption1: ListChatSessionLinksSecurityOption1,
): string {
  return JSON.stringify(
    ListChatSessionLinksSecurityOption1$outboundSchema.parse(
      listChatSessionLinksSecurityOption1,
    ),
  );
}

/** @internal */
export type ListChatSessionLinksSecurityOption2$Outbound = {
  "chat_sessions_token_header_Gram-Chat-Session": string;
};

/** @internal */
export const ListChatSessionLinksSecurityOption2$outboundSchema: z.ZodMiniType<
  ListChatSessionLinksSecurityOption2$Outbound,
  ListChatSessionLinksSecurityOption2
> = z.pipe(
  z.object({
    chatSessionsTokenHeaderGramChatSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      chatSessionsTokenHeaderGramChatSession:
        "chat_sessions_token_header_Gram-Chat-Session",
    });
  }),
);

export function listChatSessionLinksSecurityOption2ToJSON(
  listChatSessionLinksSecurityOption2: ListChatSessionLinksSecurityOption2,
): string {
  return JSON.stringify(
    ListChatSessionLinksSecurityOption2$outboundSchema.parse(
      listChatSessionLinksSecurityOption2,
    ),
  );
}

/** @internal */
export type ListChatSessionLinksSecurity$Outbound = {
  Option1?: ListChatSessionLinksSecurityOption1$Outbound | undefined;
  Option2?: ListChatSessionLinksSecurityOption2$Outbound | undefined;
};

/** @internal */
export const ListChatSessionLinksSecurity$outboundSchema: z.ZodMiniType<
  ListChatSessionLinksSecurity$Outbound,
  ListChatSessionLinksSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => ListChatSessionLinksSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => ListChatSessionLinksSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function listChatSessionLinksSecurityToJSON(
  listChatSessionLinksSecurity: ListChatSessionLinksSecurity,
): string {
  return JSON.stringify(
    ListChatSessionLinksSecurity$outboundSchema.parse(
      listChatSessionLinksSecurity,
    ),
  );
}

/** @internal */
export type ListChatSessionLinksRequest$Outbound = {
  chat_ids: Array<string>;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  "Gram-Chat-Session"?: string | undefined;
};

/** @internal */
export const ListChatSessionLinksRequest$outboundSchema: z.ZodMiniType<
  ListChatSessionLinksRequest$Outbound,
  ListChatSessionLinksRequest
> = z.pipe(
  z.object({
    chatIds: z.array(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    gramChatSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      chatIds: "chat_ids",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      gramChatSession: "Gram-Chat-Session",
    });
  }),
);

export function listChatSessionLinksRequestToJSON(
  listChatSessionLinksRequest: ListChatSessionLinksRequest,
): string {
  return JSON.stringify(
    ListChatSessionLinksRequest$outboundSchema.parse(
      listChatSessionLinksRequest,
    ),
  );
}
